import { EvaluatedFlowPage } from 'src/lib/flow/FlowPage';
import { AnswerSet } from 'src/store/sellerFlow/AnswerSet';

import QuestionField, { QuestionFieldsContainer } from '../../layouts/QuestionField';

type FlowPageContentProps = {
  page: EvaluatedFlowPage;
  answers: AnswerSet;
};

const FlowPageContent: React.FC<FlowPageContentProps> = ({ page, answers }) => {
  return (
    <QuestionFieldsContainer>
      {page.questions
        ?.filter((q) => !q.hidden)
        .map((question) => {
          return <QuestionField key={question.key} answers={answers} question={question} />;
        })}
    </QuestionFieldsContainer>
  );
};

export default FlowPageContent;
